export default [
  {
    value: 0,
    text: "Все типы"
  },
  {
    value: 1,
    text: "ГЦБ"
  },
  {
    value: 2,
    text: "ЕВРО облигации"
  },
  {
    value: 3,
    text: "Акции"
  },
  {
    value: 4,
    text: "ADR/GDR"
  },
  {
    value: 5,
    text: "Корпоративные облигации"
  },
  {
    value: 6,
    text: "Индексированные корпоративные облигации"
  }
];
